var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defaultRendererConfig, setupBingAerialImagery } from "./index";
import { Runner } from "../framework/Runner";
import { buildOrbitTrack } from "./utils/buildOrbitTrack";
import { ClassificationName, IntensityName } from "../../api";
export function skandMetadataTest(container, description) {
    return __awaiter(this, void 0, void 0, function* () {
        const htmlText = "<h1>" +
            "Skand Metadata Test 1" +
            "</h1>" +
            "<p>" +
            "The camera will fly over a tileset. The tileset should render normally. This will also attempt to load " +
            "Skand metadata on the object" +
            "</p>";
        description.innerHTML = htmlText;
        yield Runner.run(defaultRendererConfig(container), (renderer, camera) => __awaiter(this, void 0, void 0, function* () {
            setupBingAerialImagery(renderer);
            // Create the KML and give the modification callback its chance to alter the object
            setupBingAerialImagery(renderer);
            const obj = yield renderer.getObjectFactory().createTileset({
                type: "direct",
                url: "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/models/UAV_UNT/tileset.json",
            });
            renderer.getWorld().addObject(obj);
            description.innerHTML =
                htmlText +
                    "<p>" +
                    `Intensity: ${obj.pointChannels[IntensityName] !== undefined}. Expected 'true'` +
                    "</p>" +
                    "<p>" +
                    `Classification: ${obj.pointChannels[ClassificationName] !== undefined}. Expected 'true'` +
                    "</p>";
            if (obj.pointChannels[IntensityName] === undefined)
                throw new Error("Expected Intensity, got nothing");
            if (obj.pointChannels[ClassificationName] === undefined)
                throw new Error("Expected Classification, got nothing");
            const { pTrack, rTrack } = buildOrbitTrack(obj, camera, 5);
            return [pTrack, rTrack];
        }));
    });
}
